import { render } from "./MultiPersonTransfer.vue?vue&type=template&id=fceabd34&scoped=true"
import script from "./MultiPersonTransfer.vue?vue&type=script&lang=js"
export * from "./MultiPersonTransfer.vue?vue&type=script&lang=js"

import "./MultiPersonTransfer.vue?vue&type=style&index=0&id=fceabd34&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fceabd34"]])

export default __exports__